$(document).ready(function () {
    $scrollButton = $("#back-to-top");
    $navigateTopics = $("#navigate-topics");

    $(window).scroll(function () {
        if($navigateTopics){
            const navigateTopicsOffset = $navigateTopics.offset().top;
            if ($(this).scrollTop() > navigateTopicsOffset) {
                $scrollButton.show();
            } else {
                $scrollButton.hide();
            }
        }     
    });
  });
  

